import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export interface PhotoPackage {
  id: string;
  name: string;
  description?: string;
  createdAt: any;
  createdBy: string;
  priceUsd?: number;
  tags?: string[];
  version?: number | string;
  isPublished: boolean;
  stats?: {
    images: number;
    categories: string[];
  };
  bundleUri?: string;
}

export function usePhotoPackages() {
  const [packages, setPackages] = useState<PhotoPackage[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    const packagesRef = collection(db, 'photoPackages');
    
    // Query only published packages
    const q = query(
      packagesRef,
      where('isPublished', '==', true)
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const packagesData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })) as PhotoPackage[];
        
        // Sort by createdAt descending (most recent first)
        packagesData.sort((a, b) => {
          const aTime = a.createdAt?.toMillis?.() || a.createdAt?.toDate?.()?.getTime() || 0;
          const bTime = b.createdAt?.toMillis?.() || b.createdAt?.toDate?.()?.getTime() || 0;
          return bTime - aTime;
        });

        setPackages(packagesData);
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.error('Failed to load photo packages', err);
        setPackages([]);
        setLoading(false);
        setError('Failed to load photo packages');
      }
    );

    return unsubscribe;
  }, []);

  return { packages, loading, error };
}




